import React, { useEffect, useState } from 'react';
import { func, number, string, shape, bool } from 'prop-types';
import { Box, Button, IconButton, Typography } from '@mui/material';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';

import { HeaderWrapper, Badge } from './styles';
import { CopyButton, InputField, Modal, PermissionGate } from '../../../../../../../../components';
import { Drawer } from '..';
import staticText from '../../../../../../../../localization/Application/Simulator/simulator';
import { handleVinCredentials, isAutoCreatedVehicle } from '../../../../utils/utils';

const Header = ({ vehicle, deleteVehicle, autoplay }) => {
  const vehicleIsConnected = !!vehicle.smartcarId;

  const [credentialsDrawerOpen, setCredentialsDrawerOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const {
    make, model, year, vin, username, password,
  } = vehicle;
  const vehicleName = `${year} ${make.trim()} ${model.trim()}`;

  useEffect(() => {
    /* istanbul ignore next */
    if (!vehicleIsConnected) {
      handleVinCredentials(vin, setCredentialsDrawerOpen);
    }
  }, []);

  return (
    <HeaderWrapper>
      <Box display="flex" gap={2}>
        <InputField
          label={staticText.vin}
          inputValues={vin}
          name="vin"
          inputReadOnly
          customInputWidth="180px"
          actions={<CopyButton content={vin} />}
        />
        {vehicleIsConnected && (
          <InputField
            label={staticText.vehicleId}
            inputValues={vehicle.smartcarId}
            name="vehicleId"
            inputReadOnly
            customInputWidth="220px"
            actions={<CopyButton content={vehicle.smartcarId} />}
          />
        )}
      </Box>
      <div>
        <Button
          id="credentials-drawer-btn"
          variant="outlined"
          color={vehicleIsConnected ? 'secondary' : 'primary'}
          onClick={() => setCredentialsDrawerOpen(true)}
        >
          {staticText.credentialsDrawerButton}
          {!vehicleIsConnected && (
            <Badge id="credential-badge"><p>!</p></Badge>
          )}
        </Button>
        <Drawer
          type="credentials"
          drawerOpen={credentialsDrawerOpen}
          setDrawerOpen={setCredentialsDrawerOpen}
          additionalProps={{
            username,
            password,
            vehicleIsConnected,
            isAutoplay: isAutoCreatedVehicle(vin),
          }}
        />
        {!autoplay && (
          <PermissionGate dashboardPermission="write_simulator">
            <IconButton id="delete-dialog-btn" variant="outlined" color="secondary" onClick={() => setDeleteDialogOpen(true)} sx={{ marginLeft: 2 }}>
              <DeleteOutlineRoundedIcon />
            </IconButton>
          </PermissionGate>
        )}
        {deleteDialogOpen && (
          <Modal
            toggleModal={() => setDeleteDialogOpen(false)}
            title={staticText.deleteVehicleDialog.heading}
            content={(
              <Typography>
                {staticText.deleteVehicleDialog.text(vehicleName)}
              </Typography>
            )}
            actions={(
              <Button
                variant="outlined"
                color="secondary"
                onClick={deleteVehicle}
              >
                {staticText.deleteVehicleDialog.submitButtonText}
              </Button>
            )}
          />
        )}
      </div>
    </HeaderWrapper>
  );
};

export default Header;

Header.propTypes = {
  vehicle: shape({
    make: string.isRequired,
    model: string.isRequired,
    year: number.isRequired,
    vin: string.isRequired,
    username: string.isRequired,
  }).isRequired,
  deleteVehicle: func.isRequired,
  autoplay: bool.isRequired,
};
